module.exports = __webpack_public_path__ + "static/media/17UN-Women5.4a5d41f0.jpg";